module.exports = __webpack_public_path__ + "static/media/E2.e28db697.mp3";


//////////////////
// WEBPACK FOOTER
// ./node_modules/jazzband/demo/samples/piano/E2.mp3
// module id = 132
// module chunks = 0